import { AxiosError } from "axios";
import api, { getPublicNonce } from "@/app/axios/axiosInstance";

export interface LoginRequest {
  email: string;
  password: string;
  captchaToken: string;
}

export interface ChangePasswordRequest {
  current_password: string;
  new_password: string;
}

export interface LoginResponse {
  success: boolean;
  status: number;
  message?: string;
  token?: string;
  expires_at?: number;
  must_change_password?: boolean;
}

export interface ResetRequest {
  identifier: string;
  captchaToken: string;
}

export interface ResetPasswordRequest {
  token: string;
  password: string;
}

export interface LoginErrorResponse {
  message?: string;
}

export const authServices = {
  login: async (data: LoginRequest ): Promise<LoginResponse> => {
    try {
      const response = await api.post("/auth/login", {
        email: data.email,
        password: data.password,
        captcha_token: data.captchaToken, 
      });
      return { ...response.data, success: true, status: response.status };
    } catch (error) {
      const axiosError = error as AxiosError<LoginErrorResponse>;
      return {
        success: false,
        status: axiosError.response?.status || 500,
        message: axiosError.response?.data?.message || "Login gagal",
      };
    }
  },
  logout: async () => {
    try {
      const response = await api.post("/auth/logout");
      return response.data;
    } catch (error) {
      console.error("Logout failed", error);
      return { success: false };
    }
  },
  resetRequest:  async (data: ResetRequest ): Promise<LoginResponse> => {
    try {
      const response = await api.post("/auth/password/reset-request", {
        identifier: data.identifier,
        captcha_token: data.captchaToken, 
      });
      return { ...response.data, success: true, status: response.status };
    } catch (error) {
      const axiosError = error as AxiosError<LoginErrorResponse>;
      return {
        success: false,
        status: axiosError.response?.status || 500,
        message: axiosError.response?.data?.message || "Reset Password gagal",
      };
    }
  },
  resetPassword: async (data: ResetPasswordRequest ): Promise<LoginResponse> => {
    try {
      const nonce = await getPublicNonce();
      const response = await api.post(
        "/auth/password/reset",
        { token: data.token, password: data.password },
        { headers: nonce ? { "X-Nonce-Token": nonce } : {} },
      );
      return { ...response.data, success: true, status: response.status };
    } catch (error) {
      const axiosError = error as AxiosError<LoginErrorResponse>;
      return {
        success: false,
        status: axiosError.response?.status || 500,
        message: axiosError.response?.data?.message || "Reset Password gagal",
      };
    }
  },
  changePassword: async (data: ChangePasswordRequest): Promise<LoginResponse> => {
    try {
      const response = await api.post("/auth/password/change", {
        current_password: data.current_password,
        new_password: data.new_password,
      });
      return { ...response.data, success: true, status: response.status };
    } catch (error) {
      const axiosError = error as AxiosError<LoginErrorResponse>;
      return {
        success: false,
        status: axiosError.response?.status || 500,
        message: axiosError.response?.data?.message || "Gagal mengganti password",
      };
    }
  },
};
